<div [class.sidebar]="isDialog">
  <div class="dialog-actions">
    @if (dialogOptions.closable) {
      <button [mat-dialog-close]="componentResult" mat-mini-fab aria-label="Close Sidebar">
        <mat-icon title="Close Sidebar">close</mat-icon>
      </button>
    }

    @if (initialized) {
      <button mat-mini-fab (click)="toggleForm(internalTest, true)"
        [disabled]="!('update' | able: internalTest)">
        <mat-icon>edit</mat-icon>
      </button>
    }
  </div>

  <div class="container">
    <!-- title section -->
    <section class="header">
      <div class="title">
        @if (internalTest?.id) {
          {{internalTest.name}}
        }
        @if (!internalTest?.id) {
          Add onsite test
        }
      </div>
    </section>
    <!-- /title section -->
  </div>

  <mat-tab-group>
    <mat-tab label="Details">
      <ng-template matTabContent>
        @if (initialized) {
          <ng-container *ngTemplateOutlet="InputFormContent"></ng-container>
        }
      </ng-template>
    </mat-tab>
    <mat-tab label="Fields">
      <ng-template matTabContent>
        <app-fields
          recordRange="true"
          context="fields"
          entityType="internal-test"
          [entity]="internalTest"
        ></app-fields>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>


<ng-template #InputFormContent>
  <!-- Input Form -->
  <form [formGroup]="inputForm">
    <div class="container">
      <!-- name section -->
      <section>
        <div class="mat-body-2 row">Name:</div>
        @if (!editing) {
          <div class="mat-body">{{internalTest.name}}</div>
        }
        @if (editing) {
          <mat-form-field>
            <input matInput type="text" autocomplete="off" formControlName="name" [errorStateMatcher]="matcher" />
            @if (inputForm.controls.name.hasError('required')) {
              <mat-error>
                This field is <strong>required</strong>
              </mat-error>
            }
            @if (inputForm.controls.name.hasError('error')) {
              <mat-error>
                {{inputForm.controls.name.errors.error}}
              </mat-error>
            }
          </mat-form-field>
        }
      </section>
      <!-- /name section -->

      <!-- record_by_station section -->
      <section>
        <div class="mat-body-2 row">
          <div>Record by station:</div>
          <div class="icons">
            @if (!editing) {
              @if (internalTest?.record_by_station) {
                Yes
              }
              @if (!internalTest?.record_by_station) {
                No
              }
            }
            @if (editing) {
              <mat-slide-toggle formControlName="record_by_station"></mat-slide-toggle>
              @if (inputForm.controls.record_by_station.hasError('required')) {
                <mat-error>
                  This field is <strong>required</strong>
                </mat-error>
              }
              @if (inputForm.controls.record_by_station.hasError('error')) {
                <mat-error>
                  {{inputForm.controls.record_by_station.errors.error}}
                </mat-error>
              }
            }
          </div>
        </div>
      </section>
      <!-- /record_by_station section -->

      <!-- issuetype section -->
      <section>
        <div class="mat-body-2 row">Failed Issue Category:</div>
        @if (!editing) {
          <div class="mat-body">{{internalTest.issue_type}}</div>
        }
        @if (editing) {
          <mat-form-field>
            <mat-label>Failed Issue Category</mat-label>
            <mat-select formControlName="issue_type" [errorStateMatcher]="matcher">
              <mat-option [value]="">- select one -</mat-option>
              @for (issueType of issueTypes; track issueType) {
                <mat-option [value]="issueType.type">
                  {{issueType.type}}
                </mat-option>
              }
            </mat-select>
            @if (inputForm.controls.issue_type.hasError('error')) {
              <mat-error>
                {{inputForm.controls.type.errors.error}}
              </mat-error>
            }
          </mat-form-field>
        }
      </section>
      <!-- /name section -->

      <!-- Form Actions -->
      <section>
        @if (editing) {
          <div class="row">
            <button mat-stroked-button color="accent" (click)="save()">
              @if (internalTest?.id) {
                Update
              }
              @if (!internalTest?.id) {
                Create
              }
            </button>
            <button mat-stroked-button (click)="onCancel()">Cancel</button>
          </div>
        }
      </section>
      <!-- Form Actions -->
    </div>
  </form>
  <!-- /Input form -->
</ng-template>